import { useOrganizationStore } from '../stores/useOrganizationStore';
import {
  ClientOwner,
  getClientOwner,
} from '../constants/clientOwners';

/**
 * Returns the Speculo team member assigned as the active org's Client Owner.
 * Falls back to the default (Ben) when no org is loaded or the field is unset.
 *
 * Use in any client-support surface (Schedule Call modal, crash-course banner,
 * flow strategy CTAs, etc.) so the displayed contact follows the org's
 * `client_owner` assignment.
 */
export const useClientOwner = (): ClientOwner => {
  const clientOwner = useOrganizationStore((s) => s.organization?.client_owner);
  return getClientOwner(clientOwner);
};
